import styled from 'styled-components';
import Grid from 'components/core/Grid';
import { Box } from '@mui/material';

// Content Wrapper and overrides

export const SaleDate = styled(Box)`
display: flex;
align-items: center;

& svg {
  margin-right: ${props => props.theme.spacing(1)};
}

`;

export const CircleBullet = styled.span`
  background-color: ${props => props.theme.palette.secondary.main};
  padding: 0 ${props => props.theme.spacing(1)};
  color: #fff;
  border-radius: 50%;
  margin-right: ${props => props.theme.spacing(1)};
`;

// Header Box
export const HeaderWrapper = styled(Grid)`
  width: 100%;
  max-width: ${props => props.theme.breakpoints.values.lg}px;
  padding: 0 ${props => props.theme.spacing(3)};
  padding-top: ${props => props.theme.spacing(2)};

  ${props => props.theme.breakpoints.down('md')} {
    padding: ${props => props.theme.spacing(1)};
    justify-content: center;
  }
`;

export const HeaderLogo = styled(Grid)`
  & img {
    height: 60px;
  }
  ${props => props.theme.breakpoints.down('md')} {
    text-align: center;
    width: 100%;
    height: auto;
  }
`;

export const HeaderLinks = styled(Grid)`
  display: flex;
  justify-content: flex-end;

  & .MuiButton-root:not(:first-child) {
    border-left: 1px solid #e7e7e7;
    padding-left: ${props => props.theme.spacing(2)};
  }

  & .MuiButton-root:not(:last-child) {
    padding-right: ${props => props.theme.spacing(2)};
  }

  ${props => props.theme.breakpoints.down('md')} {
    display: none;
  }
`;

// Content Section
export const ContentSection = styled(Box)`
  width: 100%;
  max-width: ${props => props.theme.breakpoints.values.lg}px;
  padding: 0 ${props => props.theme.spacing(3)};
  margin-top: ${props => props.theme.spacing(8)} !important;

  ${props => props.theme.breakpoints.down('md')} {
    border-top: 1px dashed ${props => props.theme.palette.grey[300]};
    margin-top: ${props => props.theme.spacing(4)} !important;
    padding-top: ${props => props.theme.spacing(4)} !important;
  }
`;

export const ContentFullBar = styled(Box)`
  width: 100%;
  margin-top: ${props => props.theme.spacing(8)} !important;
  background-color: ${props => props.theme.palette.primary.main};
  color: #fff;
  padding: ${props => props.theme.spacing(6)} 0;
  justify-content: center;
  display: flex;
`;

export const ContentFullBarInfo = styled(Grid)`
  max-width: ${props => props.theme.breakpoints.values.lg}px;
  display: flex;
  justify-content: center;
  text-align: center;

  & .MuiButtonBase-root {
    border: 1px solid #fff;
  }
`;